import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const messages = {
  shippingCompany: 'Transportadora',
  from: 'De',
  to: 'Para',
  cityState: 'Cidade - UF',
  originZipCode: 'CEP de origem',
  destinyZipCode: 'CEP de destino',
  address: 'Endereço',
  district: 'Bairro',
  expiredMsg: 'Este endereço expirou, pois a entrega foi finalizada há mais de 15 dias.',
  forecastDelivery: 'Previsão de entrega',
  updatedForecastDelivery: 'Previsão de entrega atualizada',
  canceled: 'Cancelado',
  orderReceived: 'Pedido aprovado',
  waitingTransport: 'Aguardando transporte',
  inTransit: 'Em trânsito',
  delivering: 'Em rota de entrega',
  delivered: 'Entregue',
  assessmentSent: 'Obrigado! Sua avaliação foi enviada.',
  formRateTitle: 'Você está satisfeito com a entrega/coleta?',
  completelyDissatisfied: 'Completamente insatisfeito',
  completelySatisfied: 'Completamente satisfeito',
  leaveYourComment: 'Deixe seu comentário',
  invalid: 'Inválido',
  send: 'Enviar',
  receivedBy: 'Recebido por',
  recipientRelationship: 'Relação com destinatário',
  orderTracking: 'Acompanhamento do pedido',
  package: 'Pacote {{code}}',
  orderNumber: 'Número do pedido',
  purchaseDate: 'Data da compra',
  updates: 'Atualizações',
  see: 'Veja',
  more: 'mais',
  less: 'menos',
  dispatcher: 'Expedidor',
  requiredField: 'O campo {{field}} é obrigatório',
  comment: 'Comentário',
  rate: 'Avaliação',
  objectCode: 'Código do Objeto',
  mailCode: 'Código do objeto do Correios',
  shippingMethod: 'Método de envio',
  shippingMethodList: {
    P: 'Postagem',
    C: 'Coleta'
  },
  sender: 'Remetente',
  recipient: 'Destinatário',
  invoiceNumber: 'Nota Fiscal',
  pageTitle: 'Acompanhamento de pedidos Plataforma Logística - Grupo Boticario'
}

const messagesEsCO = {
  shippingCompany: 'Transportadora',
  from: 'De',
  to: 'Para',
  cityState: 'Ciudad - Departamento',
  originZipCode: 'Código postal de origen',
  destinyZipCode: 'Código postal de destino',
  address: 'Dirección',
  district: 'Barrio',
  expiredMsg: 'Esta dirección expiró, pues la entrega se finalizó hace más de 15 días.',
  forecastDelivery: 'Fecha estimada de entrega',
  updatedForecastDelivery: 'Fecha estimada de entrega actualizada',
  canceled: 'Cancelado',
  orderReceived: 'Pedido aprobado',
  waitingTransport: 'Esperando transporte',
  inTransit: 'En tránsito',
  delivering: 'En ruta de entrega',
  delivered: 'Entregado',
  assessmentSent: '¡Gracias! Su calificación fue enviada.',
  formRateTitle: '¿Está satisfecho con la entrega/recogida?',
  completelyDissatisfied: 'Completamente insatisfecho',
  completelySatisfied: 'Completamente satisfecho',
  leaveYourComment: 'Deje su comentario',
  invalid: 'Inválido',
  send: 'Enviar',
  receivedBy: 'Recibido por',
  recipientRelationship: 'Relación con el destinatario',
  orderTracking: 'Seguimiento del pedido',
  package: 'Paquete {{code}}',
  orderNumber: 'Número del pedido',
  purchaseDate: 'Fecha de la compra',
  updates: 'Actualizaciones',
  see: 'Ver',
  more: 'más',
  less: 'menos',
  dispatcher: 'Expedidor',
  requiredField: 'El campo {{field}} es obligatorio',
  comment: 'Comentario',
  rate: 'Calificación',
  objectCode: 'Número de guía',
  mailCode: 'Código del objeto de Correios',
  shippingMethod: 'Método de envío',
  shippingMethodList: {
    P: 'Envío',
    C: 'Recogida'
  },
  sender: 'Remitente',
  recipient: 'Destinatario',
  invoiceNumber: 'Factura',
  pageTitle: 'Seguimiento de pedidos Plataforma Logística - Grupo Boticario'
}

const LANGUAGE_BY_LOCALE: Record<string, string> = {
  'pt-br': 'pt-BR',
  'es-co': 'es-CO'
}

export const resolveLocale = (locale?: string | null) => {
  const normalized = locale?.trim().toLowerCase() ?? ''
  return LANGUAGE_BY_LOCALE[normalized] ?? 'pt-BR'
}

const LOCALE_STORAGE_KEY = 'tracking-locale'

export const rememberTrackingLocale = (locale?: string | null) => {
  if (!locale) return

  try {
    sessionStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch {
    return
  }
}

export const readRememberedLocale = () => {
  try {
    return sessionStorage.getItem(LOCALE_STORAGE_KEY)
  } catch {
    return null
  }
}

export const translateForLocale = (locale: string | null | undefined, key: string) => {
  return i18n.getFixedT(resolveLocale(locale))(key)
}

export const applyTrackingLocale = async (locale?: string | null) => {
  const language = resolveLocale(locale)

  rememberTrackingLocale(locale)

  if (i18n.language !== language) {
    await i18n.changeLanguage(language)
  }

  document.documentElement.lang = language
  document.title = i18n.t('pageTitle')
}

const initialLanguage = resolveLocale(readRememberedLocale())

i18n.use(initReactI18next).init({
  lng: initialLanguage,
  fallbackLng: 'pt-BR',
  react: { useSuspense: false },
  resources: {
    'pt-BR': {
      translation: {
        ...messages
      }
    },
    'es-CO': {
      translation: {
        ...messagesEsCO
      }
    }
  }
})

document.documentElement.lang = initialLanguage
